const SLANG = [
    "jamoke", "monster", "cigs",  "wordle", "drip", "ranch", "funfact", "cranked", "alerts", "koolaid", "critter", "sendit", "nfts", "bajadle",
    "kermit", "lynda", "choochin", "chooching", "dookie", "pipegang"
]

export default SLANG;